<template>
	<fragment class="menu-wrapper">
		<template v-for="(menu,i) in menus" >
			<!--无子菜单直接显示-->
			<template v-if=" !menu.children || menu.children.length < 1">
				<el-menu-item :key="i" v-if="menu.openAlone===0" :index="'/bjba/'+menu.url">
					<i :class="menu.icon"></i>
					<span slot="title">{{menu.name}}</span>
				</el-menu-item>
				<el-menu-item :key="i" v-else :index="'/'+menu.url">
					<i :class="menu.icon"></i>
					<span slot="title">{{menu.name}}</span>
				</el-menu-item>
			</template>
			<!--有子菜单需要进行递归处理-->
			<template v-else>
				<el-submenu popper-append-to-body :index="menu.menuId" :key="i">
					<template slot="title">
						<i :class="menu.icon"></i>
						<span slot="title">{{menu.name}}</span>
					</template>
					<menuItem :menus="menu.children"></menuItem>
				</el-submenu>
			</template>
		</template>
	</fragment>
</template>

<script>
	import {
		Vue,
		Component,
		Prop
	} from 'vue-property-decorator'
	@Component({
		name: 'menuItem'
	})
	export default class menuItem extends Vue {
		@Prop({
			type: Array,
			default: []
		})
		menus

		get isCollapse() {
		  return this.$store.getters.isUnfold;
		}

		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		}
		handleClose(key, keyPath) {
			console.log(key, keyPath);
		}
	};
</script>

